import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField,
} from '@mui/material';

/**
 * Port quase 1:1 de `DialogCampanha.jsx` real (já MUI v5 em produção) — só
 * troca o wrapper `DialogNew`/`HeaderInstrucao` por
 * `Dialog`/`DialogTitle`/`DialogContent`/`DialogActions` do MUI v5.
 */
export default function DialogCampanha({ open, texto, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth hideBackdrop>
      <DialogTitle>Campanha</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          multiline
          rows={4}
          disabled
          value={texto || ''}
          sx={{ '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: '#000000' } }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>OK, ENTENDI</Button>
      </DialogActions>
    </Dialog>
  );
}

DialogCampanha.propTypes = {
  open: PropTypes.bool,
  texto: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

DialogCampanha.defaultProps = {
  open: false,
  texto: '',
};
